import { CloseCircleTwoTone } from "@ant-design/icons";
import { Alert, Col, Row } from "antd";

import { Feed } from "./Feed";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { BLANK_USER_DATA, SUSPENSION_DURATION, useLocalStorage, UserData } from "./helpers";
import { IntroPage } from "./IntroPage";

const audio = new Audio("sound.mp3");

export function App() {
  const [userData, setUserData] = useLocalStorage<UserData>("userData", BLANK_USER_DATA);
  function createAccount(username: string) {
    setUserData({
      isLoggedIn: true,
      username,
      violations: 0,
    });
  }

  function tryAgain() {
    setUserData(BLANK_USER_DATA);
  }

  function handleCreateThread(content: string) {
    setUserData({
      ...userData,
      violations: userData.violations + 1,
      lastViolation: Date.now(),
      violationContent: content,
    });
  }

  // minutes remaining on suspension, or zero.
  const suspensionDelta = userData.lastViolation
    ? SUSPENSION_DURATION - (Date.now() - userData.lastViolation) / 60_000
    : 0;

  if (userData.violations > 1) {
    audio.play();

    return (
      <div style={{ margin: 12 }}>
        <Col style={{ paddingTop: 128 }}>
          <Row align="middle" justify="center" style={{ marginBottom: 32 }}>
            <CloseCircleTwoTone style={{ marginRight: 12, fontSize: 38 }} twoToneColor={["red", "#ffcccb"]} />
            <div style={{ fontSize: 24, fontFamily: "azonix" }}>YOU ARE CANCELLED</div>
          </Row>
          <Row align="middle" justify="center">
            <p>You have posted content that violates the terms of use.</p>
          </Row>
          <Row align="middle" justify="center" style={{ marginBottom: 12 }}>
            <Alert
              style={{ minWidth: "50%" }}
              type="error"
              message="Cancelled Content:"
              description={userData.violationContent}
            />
          </Row>
          <Row align="middle" justify="center">
            <p>Your account has been deleted.</p>
          </Row>
          <Row align="middle" justify="center">
            <a onClick={tryAgain}>try again</a>
          </Row>
        </Col>
      </div>
    );
  }

  // Greater than 1 to prevent "0 minutes" UI edge case.
  if (suspensionDelta > 0) {
    audio.play();

    return (
      <div style={{ margin: 12 }}>
        <Col style={{ paddingTop: 128 }}>
          <Row align="middle" justify="center" style={{ marginBottom: 32 }}>
            <CloseCircleTwoTone style={{ marginRight: 12, fontSize: 38 }} twoToneColor={["red", "#ffcccb"]} />
            <div style={{ fontSize: 24, fontFamily: "azonix" }}>YOU ARE CANCELLED</div>
          </Row>
          <Row align="middle" justify="center">
            <p>
              You have posted content that violates the terms of use. Nevertheless, it has been added to the Blockchain.
            </p>
          </Row>
          <Row align="middle" justify="center">
            <Alert
              style={{ minWidth: "50%" }}
              type="error"
              message="Cancelled Content:"
              description={userData.violationContent}
            />
          </Row>
          <Row align="middle" justify="center" style={{ marginTop: 12 }}>
            <div style={{ fontWeight: "bold" }}>
              You will be uncancelled in {Math.floor(suspensionDelta + 1).toFixed(0)} minute
              {suspensionDelta > 1 ? "s" : ""}.
            </div>
          </Row>
        </Col>
      </div>
    );
  }

  return (
    <div>
      <Header />
      {userData.isLoggedIn ? <Feed onCreate={handleCreateThread} /> : <IntroPage onCreate={createAccount} />}
      <Footer />
    </div>
  );
}
